import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "@/store/index";
//import firebase from "firebase";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import VueGtag from "vue-gtag";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(VueToast);
Vue.use(
  VueGtag,
  {
    config: { id: "UA-171546662-1" },
  },
  router
);
  
  import VueApexCharts from "vue-apexcharts";
  Vue.component("apexchart", VueApexCharts);
  
  require("./assets/styles/standard.css");
  
  
  Vue.use(BootstrapVue);
  Vue.use(BootstrapVueIcons);
  
  Vue.filter("numFormat", numFormat(numeral));
  
  Vue.use(require("vue-chartist"));
  
/*
import Axios from "axios";
Vue.use(Axios);
Vue.prototype.$http = Axios;
const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}
*/

Vue.config.productionTip = false;

export const eventBus = new Vue({
  methods: {
    consigneeWasSelectedFromModal(Consignee) {
      this.$emit("ConsigneeWasSelectedFromModal", Consignee);
    },
    setAuthLevel(authLevel) {
      this.$emit("setAuthLevel", authLevel);
    },
  },
});

/*
  const firebaseConfig = {
  apiKey: "AIzaSyAVbNt61Lf0sJh45iBr_kcM7xTkCeH1bY8",
  authDomain: "decsasys-54970.firebaseapp.com",
  databaseURL: "https://decsasys-54970.firebaseio.com",
  projectId: "decsasys-54970",
  storageBucket: "decsasys-54970.appspot.com",
  messagingSenderId: "723592985889",
  appId: "1:723592985889:web:c9fbddd10fc9dd5df3d260",
  measurementId: "G-14BXK8QCGD",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
*/
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
